export const fetchHotelCategory = async (selectedHotel) => {


    const token = localStorage.getItem('token'); // Get token from localStorage
    const apiUrl = process.env.REACT_APP_API_URL;


    if (!selectedHotel) return []; // If no hotel is selected, return an empty array

    try {
        const response = await fetch(`${apiUrl}/api/hotel/${selectedHotel}/category`,{
            headers: { 'Authorization': `Bearer ${token}`}, // Attach the token here
        });
        if (!response.ok) {
            throw new Error('Failed to fetch rooms');
        }
        const data = await response.json(); 

        console.log("categoryyyyyyyyy",data);

        return data; // Return the room data for the selected hotel
    } catch (error) {
        console.error('Error fetching rooms:', error);
        throw error; // Rethrow error to handle it in the component
    }
};
